import smoothscroll from 'src/Libraries/Polyfills/smoothscroll.js';


// kick off the polyfill!
smoothscroll.polyfill();
